import { createTheme } from '@mui/material/styles';
import palette from './variants/Palette';

const tucarTheme = createTheme({
  palette: {
    ...palette,
  },
});

export default tucarTheme;
